import { Center, Spinner } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import {
  useGetParticipationRequestQuery,
  useGetPortalSourcingEventQuery,
} from "../../../../autogen/bff-api";
import { useApiError } from "../../../../common/errors/useApiError";
import { PortalLayout } from "../components/PortalLayout";
import { EditParticipationRequestForm } from "./EditParticipationRequestForm";
import { useRecordTitle } from "../../../../common/page-title/PageTitle";
import { isSchemeProcedure } from "../../buyer/wizard/utils/procedure";

export const EditParticipationRequestPage = () => {
  const { eventId, requestId } = useParams<{ eventId: string; requestId: string }>();
  const { t } = useTranslation();
  const displayer = useApiError();

  const requestQuery = useGetParticipationRequestQuery({ requestId: requestId ?? "" }, { skip: !requestId });
  const eventQuery = useGetPortalSourcingEventQuery({ eventId: eventId ?? "" }, { skip: !eventId });
  useRecordTitle(
    eventQuery.data?.title,
    isSchemeProcedure(eventQuery.data?.procedureType) ? t("Apply to join") : t("Request to participate"),
  );

  if (requestQuery.error) return displayer.show(requestQuery.error);
  if (eventQuery.error) return displayer.show(eventQuery.error);

  if (!eventId || !requestId || !requestQuery.data || !eventQuery.data) {
    return (
      <PortalLayout>
        <Center py="24">
          <Spinner color="smPrimary" />
        </Center>
      </PortalLayout>
    );
  }

  return (
    <EditParticipationRequestForm
      eventId={eventId}
      requestId={requestId}
      request={requestQuery.data}
      event={eventQuery.data}
    />
  );
};
